import { render, staticRenderFns } from "./ChatDetail.vue?vue&type=template&id=4f220533&scoped=true"
import script from "./ChatDetail.vue?vue&type=script&lang=js"
export * from "./ChatDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatDetail.vue?vue&type=style&index=0&id=4f220533&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f220533",
  null
  
)

export default component.exports